import React, { Component, useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from "@headlessui/react";
import Dashboard from './Dashboard';
import axios from 'axios';
import { useParams } from 'react-router-dom';

export default function AdminNoteDetails() {
    const { city } = useParams();
    const [data, setData] = useState({});
    const [inventoryType, setInventoryType] = useState([]);
    const fetchData = () => {
        let queryParams = new URLSearchParams(window.location.search);
        if (!queryParams.get('customer_name')) {
            return;
        }
        axios.get(`${process.env.REACT_APP_API_URL}inventoryManagement/get-inventory-by-customer-name/${city}?customer_name=${queryParams.get('customer_name')}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            const response = res.data;
            if (response && response.success) {
                // console.log(response.data);
                setData(response.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}admin/inventoryType/getInventoryType`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            if (res && res.data && res.data.success) {
                // console.log(res.data);
                setInventoryType(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })

        fetchData();
    }, []);
    return (
        <>
            <Dashboard>
                <div className="mt-8 relatve overflow-x-auto shadow-md sm:rounded-lg h-[90vh]">
                    <table className="w-full text-gray-500">
                        <thead className="text-xs text-black bg-gray-50 sticky top-0 z-10">
                            <tr className="text-base text-center text-[14px]">
                                <th scope="col" className="px-1 py-3 text-[14px]">
                                    Meter Type
                                </th>
                                <th scope="col" className="px-1 py-3 text-[14px]">
                                    Count
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                inventoryType && inventoryType.length ?
                                    Object.keys(data).length !== 0 ?
                                        inventoryType.map((item, idx) => (
                                            <tr className="text-base text-center text-[14px]" key={idx}>
                                                <th scope="row" className="px-1 py-3 text-[14px]">
                                                    <p>{item.meter_type}</p>
                                                </th>
                                                <th scope="row" className="px-1 py-3 text-[14px]">
                                                    <p>{data[item.meter_type] || 0}</p>
                                                </th>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <th>No Data found</th>
                                        </tr>
                                    :
                                    <tr>
                                        <div className="text-center">
                                            <svg
                                                role="status"
                                                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"
                                                />
                                            </svg>
                                        </div>
                                    </tr>
                            }
                            <tr scope="row" className="px-1 py-3 text-[16px] text-black">
                                <th>
                                    <p>Total</p>
                                </th>
                                <th>
                                    <p>{Object.values(data).reduce((sum, value) => sum + value, 0)}</p>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Dashboard>
        </>
    )
}